import type { IconType } from 'react-icons';

interface Props {
  icon: IconType;
  title?: string;
  description: string;
}

/**
 * インサイトタブ内の各セクション（グラフ/ファネル/テーブル）でデータがない場合に表示する空状態。
 */
export default function InsightEmptyState({
  icon: Icon,
  title = '表示可能なデータがありません',
  description,
}: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-md py-10 text-center">
      <div className="flex size-16 items-center justify-center rounded-full bg-[#f3f4f6]">
        <Icon className="size-10 text-gray-400" />
      </div>
      <div className="flex flex-col gap-xs">
        <p className="m-0 text-heading-xs text-main">{title}</p>
        <p className="m-0 text-body-sm text-sub">{description}</p>
      </div>
    </div>
  );
}
